import React, {useContext, useState} from 'react';
import {Dialog, DialogActions, DialogContent, DialogContentText, TextField} from "@mui/material";
import DialogTitle from "@mui/material/DialogTitle";
import {Alert} from "@mui/lab";
import Box from "../../../../Common/Box";
import Button from "@mui/material/Button";
import {ColorButton} from "../../../../Common/ColorButton";
import shadowClient from "../../../clients/shadow/shadowClient";
import {ThemeContext} from "../../../../Common/Contexts";
import {notifier} from "../../../Notifier";
import {PartialTheme, ShadowTheme, ThemeData} from "../../../clients/shadow/interfaces";

const ThemeDialog = ({theme, open, onClose}: {
    theme: PartialTheme,
    open: boolean,
    onClose: () => any
}) => {

    const [saveError, setSaveError] = useState("");

    const handleClose = () => {
        onClose();
        setSaveError("");
    }

    const [themeMetadata, setThemeMetadata] = useState({
        name: "",
        comment: "",
    });

    const {name: themeName, comment} = themeMetadata;

    const {themes, setThemes, setTheme} = useContext(ThemeContext);

    return <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Save theme</DialogTitle>
        <DialogContent>
            <DialogContentText>
                To save your theme please enter a theme, creator name and an optional comment.
                The theme will appear in the theme selector.
            </DialogContentText>
            <TextField
                    multiline
                    maxRows={1}
                    margin="dense"
                    id="theme_name"
                    label="Theme name"
                    type="text"
                    fullWidth
                    variant="standard"
                    value={themeName}
                    onChange={(event) => {
                        setThemeMetadata({
                            name: event.target.value,
                            comment,
                        });
                    }}
            />
            <TextField
                    multiline
                    maxRows={1}
                    margin="dense"
                    id="comment"
                    label="Comment"
                    type="text"
                    fullWidth
                    variant="standard"
                    value={comment}
                    onChange={(event) => {
                        setThemeMetadata({
                            name: themeName,
                            comment: event.target.value,
                        });
                    }}
            />

        </DialogContent>
        <DialogActions
                sx={{flexDirection: "column"}}
        >
            {saveError && <Alert
                    sx={{
                        marginBottom: "8px",
                        padding: "4px",
                    }}

                    variant="outlined"
                    severity="error"
            >
                {saveError}
            </Alert>}

            <Box row>
                <Button onClick={handleClose}>Cancel</Button>
                {/*@ts-ignore*/}
                <ColorButton
                        //@ts-ignore
                        onClick={async (event, setLoading) => {
                            const {
                                // name,
                                palette: {
                                    mode,
                                    primary,
                                    background,
                                },
                                components
                            } = theme;

                            setLoading(true);

                            //@todo allow users to upload more complex theme configs?
                            const themeData: ThemeData = {
                                theme: {
                                    // name: themeMetadata.name,
                                    palette: {
                                        mode,
                                        primary,
                                        background,
                                    },
                                    components
                                },
                                metadata: themeMetadata
                            };

                            if (!themeData.metadata.creator) {
                                const clientUser = shadowClient.getClientUser();
                                themeData.metadata.creator = {
                                    id: clientUser.id,
                                    name: clientUser.username
                                }
                            }

                            await shadowClient.postTheme(themeData)
                                    .then((shadowTheme: ShadowTheme) => {
                                        onClose();
                                        setSaveError("");
                                        setThemes([...themes, shadowTheme]);
                                        setTheme(shadowTheme);
                                        notifier.success("Saved your theme");
                                    }).catch(e => {
                                        setSaveError(e.message)
                                    }).finally(() => {
                                        setLoading(false);
                                    })

                        }}>
                    Save theme
                </ColorButton>
            </Box>

        </DialogActions>

    </Dialog>
};

export default ThemeDialog;
